/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Connection_Error_Outage_TitleInputs */



/**
* | output |
* | --- |
* | "oneAI is temporarily unavailable" |
*
* @param {Auth_Connection_Error_Outage_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_outage_title = /** @type {((inputs?: Auth_Connection_Error_Outage_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_Outage_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI ist vorübergehend nicht erreichbar")
	return /** @type {LocalizedString} */ ("oneAI is temporarily unavailable")
});